var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_vm._v(" 상품 옵션 ")]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_vm._l(_vm.optionalMaxDepth, function (depth, index) {
    return [_c('v-select', {
      key: index,
      staticClass: "mt-2",
      attrs: {
        "label": _vm.optionalNames[index],
        "items": _vm.items(depth),
        "persistent-placeholder": "",
        "outlined": "",
        "dense": "",
        "hide-details": "",
        "item-disabled": "stock"
      },
      on: {
        "input": function input($event) {
          return _vm.input(depth);
        }
      },
      model: {
        value: _vm.selected[index],
        callback: function callback($$v) {
          _vm.$set(_vm.selected, index, $$v);
        },
        expression: "selected[index]"
      }
    })];
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }